import { useEffect, useState } from "react";

/* Splash de lancement (façon apps natives) : logo Iacover sur fond vert forêt,
   apparition douce puis fondu de sortie. S'affiche une fois par lancement. */
export const SplashScreen = () => {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHidden(true), 1250);
    const t2 = setTimeout(() => setGone(true), 1700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] grid place-items-center transition-opacity duration-[450ms] ease-out"
      style={{ backgroundColor: "#1E3A2F", opacity: hidden ? 0 : 1, pointerEvents: hidden ? "none" : "auto" }}
    >
      <div className="flex flex-col items-center" style={{ animation: "splashIn 0.7s cubic-bezier(0.16,1,0.3,1) both" }}>
        <img src="/logo-mark-light.png" alt="Iacover" className="h-10 w-auto" />
        <p className="mt-3 text-[11px] font-mono uppercase tracking-[0.28em] text-white/50">
          Audit d'assurance par IA
        </p>
        <div className="mt-7 flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-white/70" style={{ animation: "splashDot 1s ease-in-out infinite", animationDelay: "0ms" }} />
          <span className="w-1.5 h-1.5 rounded-full bg-white/70" style={{ animation: "splashDot 1s ease-in-out infinite", animationDelay: "160ms" }} />
          <span className="w-1.5 h-1.5 rounded-full bg-white/70" style={{ animation: "splashDot 1s ease-in-out infinite", animationDelay: "320ms" }} />
        </div>
      </div>
      <style>{`
        @keyframes splashIn {
          from { opacity: 0; transform: translateY(10px) scale(0.96); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes splashDot {
          0%, 100% { opacity: 0.25; transform: translateY(0); }
          50% { opacity: 1; transform: translateY(-3px); }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
